<template>
  <div class="lg:mt-10 md:mt-9 mt-5 lg:flex md:flex gap-2">
    <div class="container">
      <div class="w-full lg:flex md:flex gap-4">
        <div class="lg:w-3/12 md:w-4/12 w-full">
          <img
            src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/Images%20for%20Dementia%20Page/About%201.jpg"
            alt="dementia"
            class="firstabs_img object-cover"
          />
          <!-- </div>
        <div class="lg:w-3/12 md:w-4/12 w-full"> -->
          <img
            src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/Images%20for%20Dementia%20Page/About%202.jpg"
            alt="dementia"
            class="secondtabs_img object-cover"
          />
          <!-- </div>
        <div class="lg:w-3/12 md:w-4/12 w-full"> -->
          <img
            src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/Images%20for%20Dementia%20Page/About%203.jpg"
            alt="dementia"
            class="firstabs_img object-cover"
          />
        </div>
        <div class="lg:w-9/12 md:w-8/12 w-full lg:mt-0 md:mt-0 mt-4">
          <div>
            <h2 class="fsize32 sm-fsize24 font-bold text4F0A4B">
              What is Dementia?
            </h2>
            <p class="fsize16 sm-fsize14">
              Dementia is a term used to describe a range of symptoms associated
              with a decline in cognitive ability, including memory loss,
              impaired thinking, and difficulty communicating. Dementia is not a
              specific disease but rather a term used to describe a group of
              symptoms associated with cognitive decline.  <br />
              Dementia is caused by damage to brain cells, which affects the way
              the brain functions. This damage can be caused by a variety of
              factors, including Alzheimer's disease, vascular dementia, and
              Lewy body dementia. 
            </p>
            <!-- </div>
          <div class="ml-4 w-3/5"> -->
            <h2 class="fsize20 font-bold text4F0A4B mt-10 mb-4">
              What are the various forms of dementia?
            </h2>
            <div class="mt-2">
              <ul class="list-disc ml-4">
                <li class="fsize16 pb-2">
                  <span class="font-semibold">Alzheimer's disease</span>
                  is the most common cause of dementia and accounts for 60-80%
                  of cases. Alzheimer's disease is a progressive brain disorder
                  that affects memory, thinking, and behavior. The disease is
                  caused by abnormal protein deposits in the brain that
                  gradually destroy brain cells.
                </li>
                <li class="fsize16 pb-2">
                  <span class="font-semibold">Vascular dementia</span>
                  is caused by reduced blood flow to the brain, often as a
                  result of a stroke or a series of small strokes. The symptoms
                  of vascular dementia can vary depending on the location of the
                  brain damage.
                </li>
                <li class="fsize16 pb-2">
                  <span class="font-semibold">Lewy body dementia</span>
                  is caused by the accumulation of abnormal protein deposits in
                  the brain, known as Lewy bodies. The symptoms of Lewy body
                  dementia can include visual hallucinations, sleep
                  disturbances, and fluctuations in attention and alertness.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="mt-16">
        <div class="text-center w-2/3 mx-auto">
          <h2 class="text4F0A4B fsize24 sm-fsize16 mb-2">
            Some Common<span class="font-semibold"> Symptoms of Dementia</span>
          </h2>
          <p class="lg:mb-4 md:mb-4 mb-2 sm-fsize14">
            The symptoms of dementia can vary from person to person, and the
            severity of the symptoms can also vary.
          </p>
        </div>
        <div class="lg:mt-12 md:mt-10 mt-6 grid grid-cols-3 gap-x-6 gap-y-8">
          <div class="text-center">
            <img
              src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/Images%20for%20Dementia%20Page/Memory%20loss.jpg"
              alt="sign"
              class="sign_img object-cover"
            />
            <p class="pt-2 fsize16 font-semibold text-center sm-lh-20px">
              Memory loss
            </p>
          </div>
          <div class="">
            <img
              src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/Images%20for%20Dementia%20Page/Difficulty%20Communicating.jpg"
              alt="sign"
              class="sign_img object-cover"
            />
            <p class="pt-2 fsize16 font-semibold text-center sm-lh-20px">
              Difficulty Communicating
            </p>
          </div>
          <div class="">
            <img
              src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/Images%20for%20Dementia%20Page/Impaired%20Thinking%20and%20Reasoning.jpg"
              alt="sign"
              class="sign_img object-cover"
            />
            <p class="pt-2 fsize16 font-semibold text-center sm-lh-20px">
              Impaired Thinking and Reasoning
            </p>
          </div>
          <div class="">
            <img
              src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/Images%20for%20Dementia%20Page/Changes%20in%20mood%20and%20personality.JPG"
              alt="sign"
              class="sign_img object-cover"
            />
            <p class="pt-2 fsize16 font-semibold text-center sm-lh-20px">
              Changes in mood and personality
            </p>
          </div>
          <div class="">
            <img
              src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/Images%20for%20Dementia%20Page/Difficulty%20with%20spatial%20awareness%20and%20coordination.jpg"
              alt="sign"
              class="sign_img object-cover"
            />
            <p class="pt-2 fsize16 font-semibold text-center sm-lh-20px">
              Difficulty with spatial awareness and coordination
            </p>
          </div>
          <div class="">
            <img
              src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/Images%20for%20Dementia%20Page/Difficulty%20performing%20daily%20tasks.jpg"
              alt="sign"
              class="sign_img object-cover"
            />
            <p class="pt-2 fsize16 font-semibold text-center sm-lh-20px">
              Difficulty performing daily tasks
            </p>
          </div>
        </div>
      </div>
      <p class="fsize16 text-dark mt-8">
        While there is currently no cure for dementia, there are several
        treatment options available to help manage the symptoms. Medications can
        help improve cognitive function and manage behavioural symptoms such as
        agitation and aggression. Therapies such as occupational therapy, speech
        therapy, and music therapy can also be helpful in managing the symptoms
        of dementia. <br />
        As a caregiver, it is important to be aware of the symptoms of dementia
        and to seek medical attention if you suspect that your loved one may be
        experiencing cognitive decline. A diagnosis of dementia can be
        overwhelming, but there are resources available to help manage the
        symptoms and provide support to both the individual with dementia and
        their caregivers. <br />
        In conclusion, dementia is a term used to describe a group of symptoms
        associated with cognitive decline. It is caused by damage to brain
        cells, which can be caused by a variety of factors. While there is
        currently no cure for dementia, there are treatment options available to
        help manage the symptoms. As a caregiver, it is important to be aware of
        the symptoms of dementia and to seek medical attention if you suspect
        that your loved one may be experiencing cognitive decline.
      </p>
    </div>
    <!-- <div class="border-left lg:w-2/12 md:w-2/12 w-full lg:mt-0 md:mt-0 mt-4">
      <SideBlogs />
    </div> -->
  </div>
</template>
<script>
import SideBlogs from "./components/SideBlogs.vue";
export default {
  components: {
    SideBlogs,
  },
};
</script>
<style>
@media (max-width: 640px) {
  .firstabs_img {
    width: 100% !important;
  }
  .secondtabs_img {
    width: 100% !important;
  }
  .sm-lh-20px {
    line-height: 20px;
  }
}
.firstabs_img {
  height: 210px;
  width: 210px;
  border-radius: 80px 0 80px 0;
}
.secondtabs_img {
  height: 210px;
  width: 210px;
  border-radius: 0 80px 0 80px;
  margin: 12px 0 12px 0;
}
.sign_img {
  width: 220px;
  height: 220px;
  border-radius: 50% 50% 0 0;
  margin: auto;
}
</style>
